import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { Message } from 'app/layout/common/messages/messages.types';
import { tap } from 'rxjs/operators';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class MessagesService
{
    get messageURL(): any{
        return {
            unreadCountUrl: `${this.dataCollectorService.baseurl()}/messaging/message/unread-count`,
            getUnreadMessagesUrl: `${this.dataCollectorService.baseurl()}/messaging/message/unread`,
            markAsRead: `${this.dataCollectorService.baseurl()}/messaging/message/mark-as-read`
        };
    }
    unreadMessagesCount: ReplaySubject<number> = new ReplaySubject<number>(0);
    showMessageTab: boolean= false;
    updateMessage: ReplaySubject<any> = new ReplaySubject<any>(1);
    private _messages: ReplaySubject<Message[]> = new ReplaySubject<Message[]>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient,
        private dataCollectorService: DataCollectorService,
        ){}

    getUnreadMessageUrl(): string {
        return `${this.dataCollectorService.baseurl()}/messaging/message/unread`;
    }

    getUnreadCountUrl(): string {
        return `${this.dataCollectorService.baseurl()}/messaging/message/unread-count`;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for messages
     */
    get messages$(): Observable<Message[]>
    {
        return this._messages.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all messages
     */
    getAll(): void {
        this._httpClient.get<[]>(this.getUnreadMessageUrl()).subscribe((messages) => {
            this._messages.next(messages);
        });
    }
}
